import { combineReducers } from "redux";
import Theme from "./Theme";
import Snelstart from "./Snelstart";
import Queries from "./Queries";
import { firebaseReducer } from "react-redux-firebase";
import { firestoreReducer } from "redux-firestore";

const reducers = combineReducers({
  firebaseReducer,
  firestoreReducer,
  theme: Theme,
  snelstartReducer: Snelstart,
  queries: Queries,
});

export default reducers;
